import styled from 'styled-components';

export const BeforAfterMain = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 80%;
  }
  position: relative;
  height: 40vh;

  input {
    position: absolute;
    -webkit-appearance: none;
    top: 0;
    appearance: none;
    width: 100%;
    z-index: 50;
    height: 100%;
    background: transparent;
    outline: none;
    margin: 0;

    ::-webkit-slider-thumb {
      appearance: none;
      transition: all 0.5s ease-in-out !important;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 60px;
      height: 40vh;
      transition: all 0.5s ease-in-out !important;
      background: rgba(255, 255, 255, 0);
      opacity: 0;

      @media (min-width: 768px) {
        cursor: pointer;
      }
    }
  }
`;
export const AfterImageContainer = styled.div`
  background: url(${(props) => props.bgImage});
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: ${(props) => props.bgImageWidth} 100%;
  transition: width 1s ease-in-out;
  z-index: 20;
`;
export const BeforeImageContainer = styled.div`
  width: ${(props) => props.defaultWidth}%;
  background: url(${(props) => props.bgImage});
  position: absolute;
  top: 0;
  left: 0;
  background-size: ${(props) => props.bgImageWidth} 100%;
  height: 100%;
  transition: width 500ms ease-in-out;
  z-index: 30;
  overflow: hidden;

  &.noTransition {
    transition: none;
  }
`;
export const ResizeButtons = styled.div`
  width: min-content;
  position: relative;
  top: calc(50% - 20px);
  z-index: 90;
  left: calc(${(props) => props.defaultWidth}% - 20px);
  user-select: none;
  transition: left 500ms ease-in-out;
  pointer-events: none;

  &.noTransition {
    transition: none;
  }

  &:after {
    content: '';
    width: 6px;
    position: absolute;
    height: calc(20vh - 20px);
    background: white;
    left: calc(50% - 3px);
    top: 92%;
  }

  &:before {
    content: '';
    width: 6px;
    position: absolute;
    height: calc(20vh - 20px);
    background: white;
    bottom: 100%;
    left: calc(50% - 3px);
  }

  .sliderImage {
    width: 40px;
    height: 40px;
  }
`;
export const ToolTip = styled.div`
  position: absolute;
  top: 43%;
  left: calc(${(props) => props.defaultWidth}% - 180px);
  z-index: 40;
  font-size: 12px;
  color: #fff;
  cursor: pointer;

  p {
    background: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
    max-width: 70%;
    padding: 7px;
  }

  &:after {
    content: '';
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-left: 19px solid rgba(0, 0, 0, 0.6);
    border-bottom: 8px solid transparent;
    position: absolute;
    display: block;
    top: 30%;
    right: 21%;
  }
`;

export const ComparisionTitle = styled.p`
  font-size: clamp(16px, 2vw, 20px);
  font-weight: 600;
  color: #000;
  opacity: 0.9;
`;

export const ComparisionDesc = styled.p`
  font-size: clamp(12px, 2vw, 14px);
  font-weight: 500;
  margin: 15px 0 25px;
  opacity: 0.9;
`;

export const PowerContentContainer = styled.div`
  padding: 20px 10px;
  overflow: hidden;
`;

export const ActionButton = styled.button`
  background: #0000008c;
  color: #fff;
  font-size: 12px;
  font-family: Montserrat;
  position: absolute;
  top: 0;
  min-width: 80px;
  outline: none;
  border: none;
  letter-spacing: 0.5px;
  padding: 10px;
  left: ${(props) => props.left && props.left};
  right: ${(props) => props.right && props.right};
`;

export const GradientSection = styled.div`
  border-radius: 6px;
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), #fff);
  width: 100%;
  height: 8px;
`;

export const SwipeImg = styled.img`
  margin: 7px 0 0 5px;
  transform: scaleX(-1);
  width: 40px;
`;

export const SwipeContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  top: 73%;
  right: calc(${(props) => 100 - props.leftOffset}% + 40px);
  animation: swipe 2s ease-in-out;
  animation-delay: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  z-index: 40;
  @keyframes swipe {
    from {
      width: 10px;
      opacity: 1;
    }
    to {
      width: 120px;
      opacity: 0;
    }
  }
`;

export const ReportsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const ReportsItem = styled.div`
  flex-basis: 45%;
  padding: 20px 0px 0;
  margin: auto;
  min-height: 120px;

  h4 {
    font-size: clamp(32px, 3vw, 48px);
    font-weight: 600;
    color: #63b0a8;
  }

  span {
    opacity: 0.87;
    font-size: clamp(12px, 2vw, 17px);
    color: #000;
  }
`;

export const AwardSection = styled.div`
  p {
    font-size: clamp(13px, 2vw, 18px);
    font-weight: 500;
    margin-top: 10px;
  }

  .awardContainer {
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
  }
`;
export const AwardItem = styled.div`
  padding: 16px 8px;
  margin-right: 10px;

  p {
    font-size: clamp(10px, 2vw, 12px);
    opacity: 0.87;
    margin-top: 12px;
  }

  div {
    position: relative;

    span {
      padding-top: 82% !important;
      position: unset !important;
    }

    img {
      object-fit: fill !important;
      position: absolute !important;
    }
  }
`;
